import { useMutation } from 'react-query';
import axios from 'axios';
import { useTokenStore } from '../../storage/tokenState';
import { INITIATE_SUBSCRIPTION_CHECKOUT } from '../../appConstants/APIEndpoint';
import { LANGUAGE } from '../../constant';
import { getSubscriptionBaseUrl } from '../../utils/apiConfig';

interface InitiateCheckoutRequest {
  amount: number;
  autoMandate: boolean;
  planId: string | number;
  referralCouponApplied: boolean;
  shouldFetchCustomerDetails: boolean;
  isUpiAvailable?: boolean;
}

interface InitiateCheckoutResponse {
  en: string;
  response: {
    success: boolean;
    data?: {
      amount: number;
      isMandate: boolean;
      sessionId: string;
      screenName: string | null;
      paymentConfigData: any[];
      cardConfig: any[];
      sessionTimestamp: number;
      authData: any;
      customerDetails: any;
      isQrUpiWidgetAvailable: boolean;
    };
  };
}

export const useInitiateSubscriptionCheckout = () => {
  const { token } = useTokenStore();

  const mutation = useMutation<InitiateCheckoutResponse, Error, InitiateCheckoutRequest>(
    async (requestData: InitiateCheckoutRequest) => {
      // Get base URL from environment (trailing slash already removed in apiConfig)
      const baseUrl = getSubscriptionBaseUrl();
      const fullUrl = `${baseUrl}${INITIATE_SUBSCRIPTION_CHECKOUT.url}`;
      
      console.log('Calling initiateSubscriptionCheckout API:', {
        url: fullUrl,
        requestData,
        hasToken: !!token?.accessToken
      });

      const response = await axios.post(fullUrl, requestData, {
        headers: {
          'Authorization': token?.accessToken || '',
          'x-zupee-source': 'web',
          // 'x-zupee-env': 'cse',
          // "z-stage-env-id":"stv-prya80a3bac",
          'language': localStorage.getItem("language") || LANGUAGE,
          'Content-Type': 'application/json',
          'Package-Name': process.env.REACT_APP_APPPACKAGENAME || 'pwa.verticalbyzupee.com',
          'appname': process.env.REACT_APP_APP_NAME || 'pwa.verticalbyzupee.com',
        }
      });

      console.log('initiateSubscriptionCheckout Response:', response.data);
      return response.data;
    }
  );

  return {
    initiateCheckoutAsync: mutation.mutateAsync,
    isLoading: mutation.isLoading,
    data: mutation.data,
    error: mutation.error
  };
};

